﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidControllerContract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const LiquidControllerABI_1 = require("./abi/LiquidControllerABI");
const App_1 = require("../App");
class LiquidControllerContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3, id) {
        super(address, web3, LiquidControllerABI_1.LiquidControllerABI.GetABI());
        this.id = id;
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("update"); });
    }
    needUpdate() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._callInSilence("needUpdate"); });
    }
    checkUpdateWorkable() {
        return __awaiter(this, void 0, void 0, function* () {
            var account = yield App_1.App.Inst.chain.getAccountAsync();
            try {
                let gas = yield this._contract.methods["update"]().estimateGas({ from: account });
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalance");
            return this._toEther(res);
        });
    }
    getBalanceToken(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalanceToken", address);
            return this._toEther(res);
        });
    }
    deposit(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const wei = this._toWei(value);
            const res = yield this._pay(wei, "deposit");
            return res;
        });
    }
    // async setMaxSwapDumpIndex(dumpIndex:Number)
    // {
    //     const wei  =this._toWei(dumpIndex+"");
    //     const res = this._send("setMaxSwapDumpIndex", wei);       
    //     return res;
    // }
    getStatus() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("getStatus"); });
    }
    getICR() {
        return __awaiter(this, void 0, void 0, function* () { return this._toEther(yield this._call("getICR")); });
    }
    getDebt() {
        return __awaiter(this, void 0, void 0, function* () { return this._toEther(yield this._call("getDebt")); });
    }
    getColl() {
        return __awaiter(this, void 0, void 0, function* () { return this._toEther(yield this._call("getColl")); });
    }
    getConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const obj = yield this._call("getConfig");
            return {
                llMinLoan: this._toEther(obj._llMinLoan + ""),
                llGas: this._toEther(obj._llGas + ""),
                loanMinReTakeUSDL: this._toEther(obj._loanMinReTakeUSDL + ""),
                swapMinUSDL: this._toEther(obj._swapMinUSDL + ""),
                maxLoanDumpIndex: this._toEther(obj._maxLoanDumpIndex + ""),
                targetICR: this._toEther(obj._targetICR + ""),
                targetReloanICR: this._toEther(obj._targetReloanICR + ""),
                stabPoolSplitPartRevers: obj._stabPoolSplitPartRevers + "",
                buyBurnSplitPartRevers: obj._buyBurnSplitPartRevers + ""
            };
        });
    }
}
exports.LiquidControllerContract = LiquidControllerContract;
//# sourceMappingURL=LiquidControllerContract.js.map